import type { FileId } from "@inrev/common";
import type { PDFViewerControl } from "@portal/components/patterns/pdf-viewer";
import { filesQueryKey } from "./files.keys";

/** Shows a file through the files endpoint, for callers that hold its id. */
export const fileViewerControl = (fileId: FileId): PDFViewerControl => ({
	fetchUrl: `/v2/files/${fileId}`,
	queryKey: filesQueryKey(fileId),
	fileId,
});
